export class Counselling {
  sType: string;
  sCompleteDate: string;
  sProviderId: string;
  sFormatType: string;
  sProviderName: string;
  sConfirmationFlag: boolean;
  sProviderType: string;
}
